import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
import { Accordion } from 'react-bootstrap';
import ReactDOMServer from 'react-dom/server';
import Sidebar from '../../../../Sidebar/Sidebar';
import AppLink from '../../../../../routing/helpers/AppLink';
import Translator from '../../../../components/helpers/Translator';
import { axiosPath } from '@/routing/helpers/router';
import useIsMounted from '@/layout/components/hooks/useIsMounted';
import errorHandler from '@/layout/components/error/ErrorHandler';

export default function DocumentManagerSidebar({ activeRoute }) {
  const { moduleBridgeHex } = useParams();
  const dispatch = useDispatch();
  const isMounted = useIsMounted();
  const auth = useSelector((state) => state.auth);
  const permissionsLevel = useSelector(
    (s) => s.module[moduleBridgeHex]?.userBridge?.permissions?.level,
  );
  const isShortVersion = useSelector(
    (s) => s.module[moduleBridgeHex]?.permissions?.resourceManager?.shortVersion,
  );

  const downloadUserGuide = async () =>
    axios
      .post(axiosPath('api_r_user_module_documentManager_userGuide_download'), {
        moduleBridgeHex,
      })
      .then(({ data }) => {
        if (isMounted.current) {
          window.open(data, '_blank');
        }
      })
      .catch((e) => dispatch(errorHandler(e)));

  return (
    <Sidebar>
      <img
        src={auth.user?.client?.logoUrl}
        className="img-fluid"
        alt={auth.user?.client?.name}
        title={auth.user?.client?.name}
      />
      <Accordion>
        <ul>
          {permissionsLevel === 1 && (
            <>
              <li
                className={`${
                  activeRoute === 'user_module_documentManager_cover' ? 'active' : ''
                }`}
              >
                <AppLink
                  path="user_module_documentManager_cover"
                  params={{
                    moduleBridgeHex,
                  }}
                  className="p-0"
                >
                  <span className="sidebar-element">
                    <span className="sb-title">Repositorio</span>
                  </span>
                </AppLink>
              </li>
              <li onClick={downloadUserGuide}>
                <span className="sidebar-element">
                  <span className="sb-title">Guía de usuario</span>
                </span>
              </li>
            </>
          )}
          <li
            className={`${
              activeRoute === 'user_module_documentManager_item_list' ? 'active' : ''
            }`}
          >
            <AppLink
              path="user_module_documentManager_item_list"
              params={{
                moduleBridgeHex,
                parentItemHex: undefined,
                page: 1,
                filtersHex: 0,
              }}
              className="p-0"
            >
              <span className="sidebar-element">
                <span className="sb-title">Consultar información</span>
              </span>
            </AppLink>
          </li>
          {!isShortVersion && (
            <li
              className={`${
                activeRoute === 'user_module_documentManager_pendingItem_list'
                  ? 'active'
                  : ''
              }`}
            >
              <AppLink
                path="user_module_documentManager_pendingItem_list"
                params={{
                  moduleBridgeHex,
                }}
                className="p-0"
              >
                <span className="sidebar-element">
                  <span className="sb-title">
                    Publicaciones pendientes de validar
                  </span>
                </span>
              </AppLink>
            </li>
          )}
          {permissionsLevel === 0 && (
              <li
                className={`${
                  activeRoute === 'user_module_documentManager_tag_list' ? 'active' : ''
                }`}
              >
                <AppLink
                  path="user_module_documentManager_tag_list"
                  params={{
                    moduleBridgeHex,
                  }}
                  className="p-0 pointer"
                >
                  <span className="sidebar-element">
                    <span className="sb-title">Palabras clave</span>
                  </span>
                </AppLink>
              </li>
          )}
        </ul>
      </Accordion>
    </Sidebar>
  );
}
